import { useTranslation } from "@/hooks/useTranslation";
import { Route } from "@/routes/st-admin/transfer-players/index";
import { Icon, TabItem, Tabs, TabsList, Typography } from "@st-marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import PlayerPoolTable from "./PlayerPoolTable";
import STAdminTransferPlayers from "./STAdminTransferPlayers";

export type PlayersTab = "transferPlayers" | "suggestions" | "database";

/** Every player list in one page; the URL carries the tab so it can be linked to. */
const STAdminPlayers = () => {
	const { t } = useTranslation();
	const navigate = useNavigate({ from: "/st-admin/transfer-players" });
	const { tab = "transferPlayers" } = Route.useSearch();

	return (
		<div className="flex flex-col gap-6">
			<Typography variant="title-md" as="h1">
				{t("admin.menuTransferPlayers")}
			</Typography>

			<Tabs
				value={tab}
				onValueChange={(value) =>
					navigate({ search: { tab: value as PlayersTab }, replace: true })
				}
			>
				<TabsList className="overflow-x-auto">
					<TabItem value="transferPlayers" Icon={<Icon name="exchange-line" />}>
						{t("admin.transferPlayers.title")}
					</TabItem>
					<TabItem value="suggestions" Icon={<Icon name="sparkling-2-line" />}>
						{t("admin.transferPlayers.suggest.title")}
					</TabItem>
					<TabItem value="database" Icon={<Icon name="database-2-line" />}>
						{t("admin.transferPlayers.database.title")}
					</TabItem>
				</TabsList>
			</Tabs>

			{tab === "transferPlayers" ? (
				<STAdminTransferPlayers />
			) : (
				<PlayerPoolTable key={tab} pool={tab} />
			)}
		</div>
	);
};

export default STAdminPlayers;
